import React, { useRef, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Formik, Form as FormikForm } from "formik";
import { NewUser } from "types/Authentication";
import ModalHeaderTitle from "layouts/users/AddEditUserModal/Header";
import { Drivers } from "types/AllUsers";
import { Tab, Tabs } from "@mui/material";
import DriverOverview from "./overview";
import DriverAccount from "./driverAccount";
import MDBox from "components/MDBox";
import AdTechModal from "./adtech";
import { CareFreeHomeOwner } from "types/Carefree";

type AddEditUserModalProp = {
  open: boolean;
  handleClose: () => void;
  isEdit: boolean;
  selectedHomeOwner?: CareFreeHomeOwner;
  addEditUser: (updatedUser: NewUser) => void;
  addEditHomeOwner: (updatedDriver: CareFreeHomeOwner) => void;
};
const CarefreeHomeOwnerModal: React.FC<AddEditUserModalProp> = (props) => {
  const {
    open,
    handleClose,
    isEdit,
    selectedHomeOwner,
    addEditUser,
    addEditHomeOwner,
  } = props;
  const formikRef = useRef<any>(null);
  const [activeTab, setActiveTab] = useState<number>(1);

  const driver: CareFreeHomeOwner = {} as CareFreeHomeOwner;

  const handleOnClose = (_: {}, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason === "backdropClick") {
      console.info("Backdrop is clicked");
    } else {
      handleClose();
    }
  };
  const onSubmit = (values) => {
    if (activeTab === 1) {
      addEditUser(values);
    } else if (activeTab === 2) {
      addEditHomeOwner(values);
    }
  };
  const handleChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div>
      <Dialog
        onClose={handleOnClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        disableEscapeKeyDown={true}
        onBackdropClick={(event) => {
          event.stopPropagation();
          return false;
        }}
      >
        <ModalHeaderTitle id="customized-dialog-title" onClose={handleClose}>
          {`${isEdit ? "Edit" : "New"} HomeOwner`}
        </ModalHeaderTitle>
        <DialogContent dividers>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
          >
            {/* <Tab label="Overview" value={0} /> */}
            <Tab label="Account" value={1} />
            <Tab label="AdTech" value={2} />
          </Tabs>

          <Formik
            initialValues={
              isEdit && !!selectedHomeOwner ? selectedHomeOwner : driver
            }
            // validate={(values) => {
            //   if (!isEdit) validateForm(values);
            // }}
            onSubmit={onSubmit}
            innerRef={formikRef}
          >
            {({ values, handleBlur, handleChange, setFieldValue }) => (
              <FormikForm>
                <MDBox mt={3}>
                  {activeTab === 0 && <DriverOverview />}
                  {activeTab === 1 && selectedHomeOwner && (
                    <DriverAccount
                      isEdit={isEdit}
                      selectedHomeOwner={selectedHomeOwner.home_owner}
                      addEditUser={onSubmit}
                    />
                  )}
                  {activeTab === 2 && selectedHomeOwner && (
                    <AdTechModal
                      isEdit={isEdit}
                      selectedHomeOwner={values}
                      addEditUser={() => {}}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />
                  )}
                </MDBox>
              </FormikForm>
            )}
          </Formik>
        </DialogContent>
        <DialogActions>
          {activeTab === 2 && (
            <Button
              onClick={() => {
                //Trigger formik button as outside the form
                if (formikRef.current) {
                  formikRef.current.handleSubmit();
                }
              }}
            >
              {isEdit ? "Edit HomeOwner" : "Add HomeOwner"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default CarefreeHomeOwnerModal;
